import { VI_LANG } from "constants/global";
import Swal from 'sweetalert2';

const getMessageError = (lang,message) => {
    if (lang === VI_LANG) {
        Swal.fire({
            title: "Thất bại",
            text: message,
            icon: "error",
            dangerMode: false
        });
    } else {
        Swal.fire({
            title: "Fail",
            text: message,
            icon: "error",
            dangerMode: false
        });
    }
}
export default getMessageError
